import { DashboardReadResultDto, DashboardValuesReadConfiguration } from '../../../models/';
import { mapDashboardReadResultDto } from './mapDashboardReadResultDto';
import { toDictionary } from '../../../common';

export function buildWidgetValues(data: DashboardReadResultDto, readConfiguration: DashboardValuesReadConfiguration) {
    const widgetValues: any[] = mapDashboardReadResultDto(data, readConfiguration.widgetConfigurationList);
    setGroupStates(readConfiguration, data, widgetValues);
    if (readConfiguration.spotValuesConfigurations) {
        setSpotValues(widgetValues, readConfiguration, data);
    }
    if (readConfiguration.logbookWidgetsObjects) {
        setLogbookEntries(readConfiguration, data, widgetValues);
    }
    if (readConfiguration.alarmsTableConfigurations) {
        setAlarmsTable(readConfiguration, data, widgetValues);
    }
    if (readConfiguration.alarmsHeatMapConfigurations) {
        setAlarmHeatMaps(readConfiguration, data, widgetValues);
    }
    if (readConfiguration.approvalTableConfigurations) {
        setApprovalTables(readConfiguration, data, widgetValues);
    }
    if (readConfiguration.qualityWidgetConfigurations) {
        setQualityWidgets(readConfiguration, data, widgetValues);
    }
    if (data.textVariables) {
        widgetValues.push(data.textVariables);
    }
    if (data.executedQueries) {
        widgetValues.push(data.executedQueries);
    }
    return widgetValues;
}

function setAlarmHeatMaps(readConfiguration: DashboardValuesReadConfiguration, data: DashboardReadResultDto, widgetValues: any[]) {
    readConfiguration.alarmsHeatMapConfigurations
        .forEach(c => {
            if (data.widgetResults && data.widgetResults[c.guid]) {
                widgetValues.push({ guid: c.guid, summary: data.widgetResults[c.guid].alarmSummaries });
            }
        });
}

function setApprovalTables(readConfiguration: DashboardValuesReadConfiguration, data: DashboardReadResultDto, widgetValues: any[]) {
    readConfiguration.approvalTableConfigurations
        .forEach(d => {
            if (data.widgetResults && data.widgetResults[d.guid]) {
                widgetValues.push({ guid: d.guid, results: data.widgetResults[d.guid].levelStatuses });
            }
        });
}

function setQualityWidgets(readConfiguration: DashboardValuesReadConfiguration, data: DashboardReadResultDto, widgetValues: any[]) {
    readConfiguration.qualityWidgetConfigurations
        .forEach(d => {
            if (data.widgetResults && data.widgetResults[d.guid]) {
                widgetValues.push({
                    guid: d.guid,
                    results: data.widgetResults[d.guid].qualityResult,
                    range: {
                        beginDateTime: readConfiguration.beginDate,
                        endDateTime: readConfiguration.endDate
                    }
                });
            }
        });
}

function setAlarmsTable(readConfiguration: DashboardValuesReadConfiguration, data: DashboardReadResultDto, widgetValues: any[]) {
    readConfiguration.alarmsTableConfigurations
        .forEach(d => {
            if (data.widgetResults && data.widgetResults[d.guid]) {
                widgetValues.push({ guid: d.guid, results: data.widgetResults[d.guid].alarmTables });
            }
        });
}

function setLogbookEntries(readConfiguration: DashboardValuesReadConfiguration, data: DashboardReadResultDto, widgetValues: any[]) {
    readConfiguration.logbookWidgetsObjects
        .forEach(d => {
            if (data.widgetResults && data.widgetResults[d.guid] && !widgetValues.filter(w => w.guid === d.guid).length) {
                const mappedObject = {
                    guid: d.guid,
                    entries: data.widgetResults[d.guid].logbookEntries,
                    values: data.widgetResults[d.guid].logbookSeriesValues
                };
                widgetValues.push(mappedObject);
            }
        });
}

function setSpotValues(widgetValues: any[], readConfiguration: DashboardValuesReadConfiguration, data: DashboardReadResultDto) {
    const valuesByWidget = toDictionary(widgetValues);
    readConfiguration.spotValuesConfigurations.forEach(d => {
        const values = data.widgetResults[d.guid].spotValues;
        if (valuesByWidget[d.guid]) {
            valuesByWidget[d.guid].values = values;
        } else {
            widgetValues.push({ guid: d.guid, values: values });
        }
    });
}

function setGroupStates(readConfiguration: DashboardValuesReadConfiguration, data: DashboardReadResultDto, widgetValues: any[]) {
    readConfiguration.groupStatesRequestObjects
        .forEach(d => {
            if (data.widgetResults && data.widgetResults[d.widgetGuid]?.groupStatesResults) {
                const res = data.widgetResults[d.widgetGuid].groupStatesResults;
                widgetValues.push({
                    guid: d.widgetGuid,
                    groupStatesResults: res.groupStatesResults,
                    states: res.states
                });
            }
        });
}